// ErrorMessageBar.tsx
import { useState } from "react";
import {
  Button,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

export default function ErrorMessageBar({ error, onRetry }) {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(false);

  const handleClickDetails = () => setShowDetails(!showDetails);

  return (
    <MessageBar intent="error">
      <MessageBarBody>
        {error.message || "An unexpected error occurred."}
        {showDetails && (
          <div>{error.stack || JSON.stringify(error, null, 2)}</div>
        )}
      </MessageBarBody>
      <MessageBarActions>
        <Button onClick={handleClickDetails}>
          {showDetails ? t("Details.Hide") : t("Details.Show")}
        </Button>
      </MessageBarActions>
    </MessageBar>
  );
}
